import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function GeoRedirect() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const pathParts = location.pathname.split("/").filter(Boolean);

        // if no country prefix (first part must be 'ae' or 'eg')
        if (!["ae", "eg"].includes(pathParts[0])) {
            const checkLocation = async () => {
                try {
                    const res = await fetch(`https://ipinfo.io/json?token=${process.env.REACT_APP_IPINFO_KEY}`);
                    const data = await res.json();

                    const country = data?.country === "AE" ? "ae" : "eg";

                    // keep rest of the path but add prefix
                    const newPath = `/${country}${location.pathname}${location.search}${location.hash}`;

                    navigate(newPath, { replace: true });
                } catch (error) {
                    console.error("Location fetch failed:", error);

                    // fallback to Egypt
                    const newPath = `/eg${location.pathname}${location.search}${location.hash}`;
                    navigate(newPath, { replace: true });
                }
            };

            checkLocation();
        }
    }, [navigate, location]);
    return null;
}


export default GeoRedirect;
